<template>
  <div>
    <router-link
      :to="!disableSelect ? `/inquiry/${redirect}/${carId}/0` : `${getInfo}`"
      v-if="getUserCar(carId).licensePlateFirstTwoDigits"
    >
      <div class="card text-color border-color background-color">
        <div v-bind:class="{ opacity: disableSelect }">
          <div>
            <h3>
              {{ getUserCar(carId).carGroupTitle }} -
              {{ getUserCar(carId).carModelTitle }}
            </h3>
          </div>
          <div>
            <div class="plate">
              <img
                class="img-plate"
                alt="پلاک"
                title="پلاک"
                src="../../assets/img/img_empty_plate.png"
              />
              <div class="two-digit">
                {{ getUserCar(carId).licensePlateFirstTwoDigits | persian }}
              </div>
              <div class="plate-alphabet">
                {{ getUserCar(carId).licensePlateAlphabet }}
              </div>
              <div class="three-digit">
                {{ getUserCar(carId).licensePlateThreeDigits | persian }}
              </div>
              <div class="iran-digit">
                {{ getUserCar(carId).licensePlateIranDigits | persian }}
              </div>
            </div>

            <!-- <div class="error-message" v-if="plateProblem">
                    {{plateProblem}}
                </div> -->
          </div>
        </div>
      </div>
    </router-link>
    <div class="card text-color border-color background-color" v-else>
      <div>
        <h3>
          {{ getUserCar(carId).carGroupTitle }} -
          {{ getUserCar(carId).carModelTitle }}
        </h3>
      </div>
      لطفا به قسمت "پروفایل" بروید و شماره پلاک خودروی ثبت شده خود را وارد
      نمایید.
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "user-car",
  props: {
    carId: { required: true },
    type: { type: String, required: true },
    redirect: { type: String, required: true },
  },
  computed: {
    ...mapGetters(["getUserCar"]),
    disableSelect: function() {
      const car = this.getUserCar(this.carId);
      if (
        this.type == "violation-inquiry_" ||
        this.type == "violation-inquiry-all_"
      ) {
        if (
          !car.LicensePlateFirstTwoDigits ||
          !car.LicensePlateAlphabet ||
          !car.LicensePlateThreeDigits ||
          !car.LicensePlateIranDigits
        ) {
          return true;
        }
      } else if (this.type == "annual-tolls") {
        if (!car.VINCode) {
          return true;
        }
      }
      return false;
    },
    plateProblem: function() {
      const car = this.getUserCar(this.carId);
      if (
        this.type == "violation-inquiry_" ||
        this.type == "violation-inquiry-all_"
      ) {
        if (
          !car.LicensePlateFirstTwoDigits ||
          !car.LicensePlateAlphabet ||
          !car.LicensePlateThreeDigits ||
          !car.LicensePlateIranDigits
        ) {
          return "برای استعلام وارد کردن پلاک خودرو الزامی است.\nبرای درج پلاک خودرو کلیک کنید";
        }
      } else if (this.type == "annual-tolls") {
        if (!car.VINCode) {
          return "برای استعلام وارد کردن شماره VIN خودرو الزامی است.\nبرای درج پلاک خودرو کلیک کنید";
        }
      }
      return null;
    },
    getInfo: function() {
      if (this.type == "car-fines") {
        return `/inquiry/barcode/${this.type}/${this.carId}`;
      } else if (
        this.type == "tehran-tolls" ||
        this.type == "freeway-tolls" ||
        this.type == "air-pollutions"
      ) {
        return `/inquiry/plate/${this.type}/${this.carId}`;
      } else if (this.type == "annual-tolls") {
        return `/inquiry/vin/${this.type}/${this.carId}`;
      }
      return "";
    },
  },
};
</script>

<style scoped>
.card {
  border: solid 1px;
  margin: 7px 10px 0 10px;
  border-radius: 5px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px;
  position: relative;
  text-align: center;
}

.card h3 {
  margin-bottom: 4px;
}

.plate {
  width: 230px;
  display: inline-block;
  padding: 0 0 0 0;
  margin: auto;
  position: relative;
}

.img-plate {
  width: 100%;
}

.plate .two-digit {
  font-family: nazanin;
  font-weight: bold;
  font-size: 30px;
  position: absolute;
  top: 10px;
  right: 157px;
  width: 50px;
  color: #555;
}

.plate .plate-alphabet {
  font-family: nazanin;
  font-weight: bold;
  font-size: 30px;
  position: absolute;
  top: 10px;
  right: 120px;
  width: 46px;
  color: #555;
}

.plate .three-digit {
  font-family: nazanin;
  font-weight: bold;
  font-size: 30px;
  position: absolute;
  top: 10px;
  right: 60px;
  width: 60px;
  color: #555;
}

.plate .iran-digit {
  font-family: nazanin;
  font-weight: bold;
  font-size: 27px;
  position: absolute;
  top: 13px;
  right: 6px;
  width: 45px;
  color: #555;
}
.opacity {
  opacity: 0.5;
}
</style>
